import { apiUrl } from 'config';
import UserProfile from "components/UserProfile/UserProfile";
import axios from 'axios';
import toast, { Toaster } from "react-hot-toast"
import API from './API';

export const getOrders = async (filters = {}) => {
    const token = await UserProfile.getToken();
    const response = await axios.get(`${apiUrl}admin/orders`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: filters
    });
    return response.data
}

export const modifyOrder = async (modifiedOrder) => {
    const token = await UserProfile.getToken();
    try {
        const response = await axios.put(
            `${apiUrl}admin/orders`,
            modifiedOrder,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        toast.success(response.data.msg);
    }
    catch (error) {
        error.response.data?.msg ? toast.error(error.response.data.msg) : toast.error(error.response.data)
    }
};

// Create an axios instance with a base URL and authentication header
const api = axios.create({
    baseURL: apiUrl,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}` // Assuming JWT auth
    }
});

export const ordersApi = {
    // Basic CRUD operations for bs-orders
    getAll: () => api.get('bs-orders/'),

    getById: (id) => api.get(`bs-orders/${id}/`),
    update: (id, data) => api.put(`bs-orders/${id}/`, data),
    archive: (id) => api.post(`bs-orders/${id}/archive/`),

    assignOrderBucket: (id, bucketId) =>
        api.patch(`bs-orders/${id}/assign-bucket/`, { bucket_id: bucketId }),
    getDirectPickupOrders: (filters) => {
        const params = new URLSearchParams(filters).toString();
        return api.get('bs-orders/direct-pickup/?' + params);
    },
    getOrdersWithSeals: (filters) => {
        const params = new URLSearchParams(filters).toString();
        return api.get(`bs-orders/orders-with-seals/?${params}`);
    },
    getActiveOrders: (filters) => {
        const params = new URLSearchParams(filters).toString();
        return api.get('bs-orders/active-orders/?' + params);
    },
    getActiveOrdersWithChangedUnits: (filters) => {
        const params = new URLSearchParams(filters).toString();
        return api.get('bs-orders/active-orders-with-changed-units/?' + params)
    },

    getActiveOrdersWithChangedVehicleSize: (filters) => {
        const params = new URLSearchParams(filters).toString();
        return api.get('bs-orders/active-orders-with-changed-vehicle-size/?' + params)
    },

    getOrdersCountPerMonth: (dateStart, dateEnd) =>
        api.get(`bs-orders/orders-count-per-month/?date_start=${dateStart}&date_end=${dateEnd}`),

    getLaneVolumePerDay: (dateStart, dateEnd) =>
        api.get(`bs-orders/orders-lanes-volume-per-day/?date_start=${dateStart}&date_end=${dateEnd}`),

    getOrderLine: (orderId) =>
        api.get(`bs-orders/${orderId}/get-order-line/`),

    getPositionUpdates: (orderId, page = 1, page_size = 10) => {
        return api.get(`bs-orders/${orderId}/position-updates/?page=${page}&page_size=${page_size}`);
    },
    getPackingPlan: (orderId) =>
        api.get(`bs-orders/${orderId}/packing-plan/`),
};

// Add request interceptor to include the token dynamically before each request
api.interceptors.request.use(async (config) => {
    const token = await UserProfile.getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;  // Include token in Authorization header
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
